<template>
  <div class="b-wrap">
    <i class="icon icon-bbb"></i>
    <v-la-ba @click="handle_click" :data="list">
    </v-la-ba>
    <Dialog title="公告"  width="50%" :visible.sync="isShow">
      <span style="line-height: 22px;text-indent: 2em;display:inline-block">{{noticeContent}}</span>
      <span slot="footer" class="dialog-footer">
    <Button type="primary" @click="consoleNoticeDialog">关闭</Button>
  </span>
    </Dialog>
  </div>
</template>
<style scoped lang="stylus">
  $height = 22px;
  .b-wrap
    width 100%
    height $height
    position relative
    font-size 14px
    box-sizing border-box
    padding-left 40px

    .icon
      width 16px
      height 15px
      display block;

    .icon-bbb
      top 50%
      left 15px
      position absolute
      transform translateY(-50%)
      background url("./images/laba.png") no-repeat center center
      background-size contain

    .c_a-wrap {
      width 100%
      height 100%
      overflow hidden
      font-size 14px
      line-height 24px
      white-space nowrap

      .c_a-item {
        display flex
        align-items center
        justify-content flex-start

        &:before {
          width 3px
          height 3px
          content ""
          display inline-block
          margin-right 5px
          vertical-align middle
          background-color #999999
        }

        .content {
          overflow hidden
          white-space nowrap
          text-overflow ellipsis
        }

        .time {
          display inline-block
          margin-left 20px
        }
      }
    }
</style>

<script>
  import VLaBa from './mini-horn';
  import {Dialog, Button} from "element-ui";

  export default {
    name: "index",
    components: {
      VLaBa,
      Dialog,
      Button
    },
    props: {
      interval: {
        type: Number,
        default: 3000
      },
      list: {
        type: Array,
        default() {
          return []
        }
      }
    },
    watch:{
      list(){
        this.openNoticeDialog();
      }
    },
    data() {
      return {
        isShow: false,
        noticeContent: "",
        first:true,
        options: {
          direction: 2,
          limitMoveNum: 2
        }
      }
    },
    methods: {
      // 打开弹窗
      handle_click(item) {
        this.$emit('click', item);
      },
      openNoticeDialog() {
        this.list.forEach((item) => {
          if (item.type == 2 && this.first) {
            this.noticeContent = item.content;
              this.isShow = true;
              this.first = false;
          }
        })
      },
      consoleNoticeDialog(){
        this.isShow=false;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/c-laba/index.vue